import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonProps } from "../../../../button/ButtonProps";
import { OpenType } from "../../../../../page/openButtons/OpenType";

export class DefaultDetailButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonDefaultDetail`,
            enabled: false,
            hotkey: "Alt-D",
            padding: 4,
            borderWidth: 0,
            margin: 0,
            marginRight: 0,
            paddingRight: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            onClick: () => this.table.crudManager.showDetail(this.table.crudManager.defaultOpenType),
            ...this.getDetailButtonProps(this.table.crudManager.defaultOpenType)
        });
    }

    override rowSelectionChanged() {
        this.button.enabled = this.table.selectedRowCount === 1;
    }

    private getDetailButtonProps(mode: OpenType): Partial<ButtonProps> {
        switch (mode) {
            case OpenType.NEW_TAB_NO_SWITCH:
                // When clicking from the toolbar, there doesn't seem like a reason to not switch to it
            case OpenType.NEW_TAB_WITH_SWITCH:
                return { imageName: ImageName.tab, tooltip: "Open the selected row in a new browser tab" };
            case OpenType.NEW_WINDOW:
                return { imageName: ImageName.overlappingWindows, tooltip: "Open the selected row in a new browser window" };
            default:
                return { imageName: ImageName.detail, tooltip: "Open the selected row in this table in this browser tab" };
        }
    }

    sync() {
        this.button.setProps(this.getDetailButtonProps(this.table.crudManager.defaultOpenType));
    }
}
